export const BROADCAST_STATUS_TABS = [
  { id: 'played', label: 'Played' },
  { id: 'sent', label: 'Sent' },
  { id: 'queued', label: 'Queued' },
  { id: 'timeout', label: 'Timeout' },
  { id: 'failure', label: 'Failure' },
  { id: 'aborted', label: 'Aborted' },
] as const;

export const QUEUED_TAB_ID = 'queued';

export function statusToTabId(status: string): string {
  const s = (status || '').toLowerCase().trim();
  if (s === 'failed') return 'failure';
  return s || 'queued';
}
